import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';
import { navLinks } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">
                动漫本子收藏指南
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">分类浏览</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category?tab=${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-600 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm text-primary-500"></i>
                </div>
                {siteInfo.email}
              </li>
              <li className="text-sm text-foreground-600 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm text-primary-500"></i>
                </div>
                {siteInfo.phone}
              </li>
              <li className="text-sm text-foreground-600 flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-sm text-primary-500"></i>
                </div>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a
              href={siteInfo.socialLinks.weibo}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line text-base"></i>
              </div>
            </a>
            <a
              href={siteInfo.socialLinks.bilibili}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="Bilibili"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bilibili-line text-base"></i>
              </div>
            </a>
            <a
              href={siteInfo.socialLinks.xiaohongshu}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="小红书"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-base"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}